module.exports = __webpack_public_path__ + "img/LuckDrawResult.8fa2b100.png";